<template>
  <button class="btn btn-outline-secondary" data-toggle="modal" :data-target="`#modal-eliminar-${item.id}`" title="Treure projecte" :class="{ disabled: loading.proyectosGestion[index] || loading.orden }" :disabled="loading.proyectosGestion[index] || loading.orden" v-tooltip><i class="fa-solid fa-circle-minus"></i></button>
</template>

<script>
export default {
  name: "BtnEliminarProyecto",
  props: ["item", "index", "loading"]
}
</script>